import effectData from '../data/effects.json';
import conditionData from '../data/conditions.json';
import filterData from '../data/filters.json';

import loadableData from '../data/loadables.json';
import soundData from '../data/sounds.json';
import rangeData from '../data/ranges.json';
import slotData from '../data/slots.json';
import mobTypeData from '../data/mob_types.json';
import durationData from '../data/durations.json';
import resourceData from '../data/resources.json';
import equipmentData from '../data/equipment.json';
import angleData from '../data/angles.json';
import potionEffectData from '../data/potion_effects.json';
import potionIdData from '../data/potion_ids.json';
import limitedColorData from '../data/limited_colors.json';
import tridentPatternData from '../data/trident_patterns.json';

function userDefined() {
    let ret = {};
    for (let i = 1; i <= 40; i ++) {
        ret[i + 1000] = {
            "display":"User-Defined #" + i,
            "value_mode":"input",
            "value_display":"Value",
            "value2_mode":"input",
            "value2_display":"Value2",
            "has_sound":true,
            "for_trident":true,
            "user_defined":true,
        }
    }
    return ret;
}

export function getEffectData() {
    return {
        ...effectData,
        ...userDefined(),
    }
}

export function getConditionData() {
    return {
        ...conditionData,
        ...userDefined(),
    }
}

export function getFilterData() {
    return {
        ...filterData,
    }
}

export function getDataByType(type) {
    if (type === 0) {
        return getEffectData();
    }
    else if (type === 1) {
        return getConditionData();
    }
    else if (type === 2) {
        return getFilterData();
    }
    else if (type === "loadable") {
        return loadableData;
    }
    else if (type === "sound") {
        return soundData;
    }
    else if (type === "range") {
        return rangeData;
    }
    else if (type === "slot") {
        return slotData;
    }
    else if (type === "mob_type") {
        return mobTypeData;
    }
    else if (type === "duration") {
        return durationData;
    }
    else if (type === "resource") {
        return resourceData;
    }
    else if (type === "equipment") {
        return equipmentData;
    }
    else if (type === "angle") {
        return angleData;
    }
    else if (type === "potion_effect") {
        return potionEffectData;
    }
    else if (type === "potion_id") {
        return potionIdData;
    }
    else if (type === "trident_pattern") {
        return tridentPatternData;
    }
    else if (type === "limited_color") {
        return limitedColorData;
    }
    else {
        return {}
    }
}
